'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkoutNext = checkoutNext;
exports.checkoutCoupon = checkoutCoupon;
exports.couponRemove = couponRemove;

var _actions = require('../helpers/actions');

function checkoutAdvance() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: 'CHECKOUT_NEXT',
    promise: function promise(_ref) {
      var api = _ref.api;
      return (0, _actions.handleErrors)(api('/checkout/next').put(data));
    }
  };
}

function checkoutPayment(id) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CHECKOUT_PAYMENT',
    promise: function promise(_ref2) {
      var api = _ref2.api;
      return (0, _actions.handlePaymentRedirect)(api('/checkout/payment').put(data));
    }
  };
}

function checkoutNext(step, id) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  data.state = step;

  if (step === 'payment') {
    return checkoutPayment(id, data);
  }

  return checkoutAdvance(data);
}

function checkoutCoupon() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: 'CHECKOUT_COUPON',
    promise: function promise(_ref3) {
      var api = _ref3.api;
      return (0, _actions.handleErrors)(api('/checkout/apply_coupon').post(data), _actions.couponCodeError);
    }
  };
}

function couponRemove() {
  return {
    type: 'COUPON_REMOVE',
    promise: function promise(_ref4) {
      var api = _ref4.api;
      return api('/checkout/remove_coupon_code').delete();
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./shared/actions/checkout.js
// module id = 2245
// module chunks = 0